/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pageBoost.vue?vue&type=template&id=36a48212"
import script from "./pageBoost.vue?vue&type=script&lang=js"
export * from "./pageBoost.vue?vue&type=script&lang=js"
import style0 from "./pageBoost.vue?vue&type=style&index=0&id=36a48212&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports